import React from "react";

const TeamContext = React.createContext({ team: null, refreshTeam: () => {} });

export default TeamContext;
